<template>
  <div>
    <div v-for="(field, i) in displayFields" :key="i + field.field">
      <v-layout py-1>
        <v-flex v-if="field.block" xs12 sm12 md12>
          <u-i-list-title>
            {{ field.label }}
          </u-i-list-title>
        </v-flex>
        <v-flex v-else xs12 sm12 md12>
          <v-layout align-center justify-start row my-2>
            <v-flex xs4>
              <span class="fields-view-order">{{ field.label }}</span>
            </v-flex>
            <v-flex xs8>
              <v-layout align-center justify-start fill-height row pl-3>
              <span class="fields-view-order-details">
                {{ formatValue(field) }}
              </span>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-layout v-if="!field.block" align-center justify-start fill-height row>
        <v-divider></v-divider>
      </v-layout>
    </div>
  </div>
</template>

<script>

import UIListTitle from '@/components/UI/ListTitle';

export default {
  name: 'UIListInfo',
  components: {
    UIListTitle,
  },
  props: {
    displayFields: {
      required: true,
      type: Array,
    },
    data: {
      required: true,
      type: Object,
    },
  },
  methods: {
    getNestedValue(obj, path) {
      return path.split('.').reduce((value, key) => {
        return value ? value[key] : '-';
      }, obj);
    },
    formatValue(field) {
      if (!field.field) return '-';
      
      const value = this.getNestedValue(this.data, field.field);
      
      if (value === null || value === undefined) return '-';

      if (field.library) {
        return this.$store.getters[field.library](value);
      }
      
      return field.prefix + value;
    }
  }
}
</script>